import { defaultColumns, defaultSort } from '../../components/sales/invoices/columns';

export default {
  state: {
    invoices: [],
    rawInvoices: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    ntaxFilterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    rawInvoices: state => state.rawInvoices,
    invoices: state => state.invoices,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    ntaxFilterString: state => state.ntaxFilterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setRawInvoices(state, invoices) {
      state.rawInvoices = invoices;
    },
    setInvoices(state, invoices) {
      state.invoices = invoices;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setNtaxFilterString(state, filter) {
      state.ntaxFilterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAllRaw({ commit, state }, queryString) {
      commit('setLoading', true);
      if (queryString) {
        commit('setNtaxFilterString', queryString.substr(1));
      } else if (queryString === '') {
        commit('setNtaxFilterString', '');
      } else {
        commit('setNtaxFilterString', state.ntaxFilterString || '');
      }
      try {
        const invoices = await axios.get('api/invoices-raw?' + state.ntaxFilterString);
        commit('setRawInvoices', invoices);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/invoice-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'invoice-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const invoices = await axios.get('api/invoices' + (query || ''));
        commit('setInvoices', invoices);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/invoices/${id}`);
    },
    async fetchPayments({ commit }, id) {
      return await axios.get(`api/invoices/payments/${id}`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/invoices/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async create({ commit }, payLoad) {
      return await axios.post('api/invoices', payLoad);
    },
    async close({ commit }, id) {
      return await axios.post(`api/invoices/close/${id}`);
    },
    async update({ commit }, payLoad) {
      return await axios.put('api/invoices', payLoad);
    },
    async storno({ commit }, id) {
      return await axios.post('api/invoices/storno/' + id);
    },
    async cancel({ commit }, id) {
      return await axios.post(`api/invoices/cancel/${id}`);
    },
    async undoCancel({ commit }, id) {
      return await axios.post(`api/invoices/undo-cancel/${id}`);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/invoices/${id}`);
    },
    async setNavStatusToSuccess({ commit }, id) {
      await axios.post(`api/invoices/set-nav-status-to-success/${id}`);
    },
    async deleteInvoiceImage({ commit }, id) {
      await axios.delete(`api/invoices/delete-invoice-image/${id}`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/invoice-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'Invoices'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
